import PhotoMotion from '@/components/feature/PhotoMotion';
import { cdn } from '@/config/cdn';

export default function VisitHero() {
  return (
    <section data-nav-dark className="bg-[#171515] text-[#F5F1EB] pt-24 md:pt-28 pb-16 md:pb-24" aria-labelledby="visit-hero-title">
      <div className="fold-shell grid grid-cols-1 lg:grid-cols-12 gap-y-8 lg:gap-x-8">
        <figure className="lg:col-span-7 lg:col-start-6 lg:row-start-1 min-w-0 m-0">
          <div className="w-full aspect-[4/5] sm:aspect-[4/3] lg:aspect-auto lg:h-[min(76vh,740px)] overflow-hidden bg-[#0f0e0e]">
            <PhotoMotion fromScale={1.035} fromY={14} duration={1.2} delay={0.05}>
            <img
              src={cdn('https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_visit-hero.webp')}
              alt="The FOLD. bakery room in the morning, with the counter and deck oven"
              title="The room — FOLD. Artisan Bakery"
              className="w-full h-full object-cover object-center"
            />
            </PhotoMotion>
          </div>
          <figcaption className="mt-3 text-[11px] tracking-[0.14em] uppercase text-[rgba(245,241,235,0.5)]">Fig. 01 — The room, before opening</figcaption>
        </figure>

        {/* Text column: same row as the photo; unit sits in the photo's lower half, bottom-aligned to the image edge (caption offset). */}
        <div className="lg:col-span-5 lg:col-start-1 lg:row-start-1 min-w-0 flex flex-col lg:pb-[30px]">
          <p className="fold-label text-[rgba(245,241,235,0.6)]">Visit / FOLD.</p>
          <div className="mt-6 lg:mt-auto lg:pb-[12%] lg:pr-6">
            <h1 id="visit-hero-title" className="fold-serif uppercase leading-[0.9] tracking-[-0.03em] text-[13vw] sm:text-[9vw] lg:text-[5.4vw] xl:text-[5.6rem]">
              Come to<br />the <span className="italic">counter.</span>
            </h1>
            <p className="mt-6 text-[15px] md:text-base leading-[1.75] text-[rgba(245,241,235,0.7)] max-w-[400px]">
              One room, one oven, one bake a day. Come for something warm, or request a pickup before you arrive.
            </p>
            <a href="#pickup" className="group mt-8 inline-flex items-center gap-2 fold-label whitespace-nowrap cursor-pointer">
              <span className="bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat bg-left-bottom bg-[length:100%_1px] group-hover:bg-[length:0%_1px] transition-[background-size] duration-500 pb-1">Request a pickup</span>
              <i className="ri-arrow-down-line transition-transform duration-300 group-hover:translate-y-0.5" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}